import { Navigate, Route, BrowserRouter as Router, Routes } from 'react-router-dom';
import RefreshToken from './components/RefreshToken';
import InspetionLogFormPage from "./pages/InspectionLogsFormPage";
import LoginPage from "./pages/LoginPage";
import ProjectElementsPage from "./pages/ProjectElementsPage";
import ProjectListPage from "./pages/ProjectListPage";
import WeldsLogFormPage from "./pages/WeldsLogFormPage";
import WeldsPage from "./pages/WeldsPage";
import PrivateRoute from './utils/PrivateRoute';



function App() {
  const isStaging = window.location.hostname.includes('staging')
  
  return (
    < Router future={{ v7_startTransition: true, v7_relativeSplatPath: true }} >
      <RefreshToken />
      {isStaging && (
        <div 
          style={{
            position: 'fixed',
            top: '20px',
            left: '50%',
            transform: 'translateX(-50%)',
            fontSize: '2.5rem',
            fontWeight: 'bold',
            color: 'red',
            zIndex: 9999,
            pointerEvents: 'none',
            textAlign: 'center'
          }}
        >
          Test Version (Staging Environment)
        </div>
      )}
      < Routes >
        < Route path="/login" element={< LoginPage />} />
        < Route path="/project-list" element={< PrivateRoute > <ProjectListPage /></PrivateRoute >} />
        < Route path="/project/:projectId" element={< PrivateRoute > <ProjectElementsPage /></PrivateRoute >} />
        < Route path="/welds/:projectId/:elementId" element={< PrivateRoute > <WeldsPage /></PrivateRoute >} />
        < Route path="/welding/:projectId/:elementId/:weldId" element={<PrivateRoute><WeldsLogFormPage /></PrivateRoute>} />
        < Route path="/inspection/:projectId/:elementId/:weldId" element={<PrivateRoute><InspetionLogFormPage /></PrivateRoute>} />
        < Route path="*" element={< Navigate to="/project-list" />} />
      </Routes >
    </Router >
  );
}

export default App;
